document.addEventListener("DOMContentLoaded", function () {

  const accordions = document.querySelectorAll(".qris-accordion");

  accordions.forEach((accordion) => {

    const header = accordion.querySelector(".qris-accordion-header");

    header.addEventListener("click", function () {

      accordion.classList.toggle("active");

    });

  });

});